import { AxiosRequestConfig } from 'axios'
import HttpClient from 'core/axios'
import { BASE_PARTNER_URL } from 'core/loader'

class CollectUserApiClient extends HttpClient {
  constructor() {
    super(BASE_PARTNER_URL)
    this.initializeRequestInterceptor()
  }

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest, this.handleError)
  }

  private handleRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    return config
  }
}

const userApiClient = new CollectUserApiClient()

export default userApiClient
